import {
  multiSelectTemplate,
  multiSelectCardTemplate,
  hiddenSelectOptionTemplate,
} from "/WebInterface/new-ui/modules/multi-select/template.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export default class MultiSelect {
  attach = ({
    input,
    leftOptions,
    leftLabel,
    rightLabel,
    onAddSelected = () => {},
    onRemoveSelected = () => {},
    onTransaction = () => {},
  }) => {
    const targetedInput = _$(input);

    const id = targetedInput.attr("id");
    const name = targetedInput.attr("name");
    const dataValidate = targetedInput.attr("data-validate");
    const dataMarkError = targetedInput.attr("data-mark-error");
    const dataInlineError = targetedInput.attr("data-inline-error");

    targetedInput.el().insertAdjacentHTML(
      "afterend",
      multiSelectTemplate({
        id,
        leftLabel,
        rightLabel,
        filterText: t("filter"),
        clearText: t("clear"),
        selectText: t("select"),
        allText: t("all"),
        noneText: t("none"),
        addSelectedText: t("addSelected"),
        removeSelectedText: t("removeSelected"),
      })
    );
    targetedInput.remove();

    // const multiSelectWrapper = _$(`#${id}`);
    const leftColumnAddSelectedButton = _$(
      `#${id} .left-column .left-column-add-selected-btn`
    );
    const rightColumnRemoveSelectedButton = _$(
      `#${id} .right-column .right-column-remove-selected-btn`
    );
    const multiSelectLeftOptionWrapper = _$(`#${id} .left-side-options`);
    const multiSelectRightOptionWrapper = _$(`#${id} .right-side-options`);

    if (dataValidate) {
      _$(multiSelectRightOptionWrapper).attr("data-validate", dataValidate);
    }
    if (dataMarkError) {
      _$(multiSelectRightOptionWrapper).attr("data-mark-error", dataMarkError);
    }
    if (dataInlineError) {
      _$(multiSelectRightOptionWrapper).attr(
        "data-inline-error",
        dataInlineError
      );
    }

    _$(multiSelectRightOptionWrapper).attr("name", name);

    this.renderOptions({ id, options: leftOptions });

    leftColumnAddSelectedButton.on("click", () => {
      _$(`#${id} .left-side-options option:checked`)
        .sel()
        .forEach((option) => {
          const value = _$(option).val()?.trim();
          const label = _$(option).text()?.trim();

          multiSelectRightOptionWrapper
            .el()
            .insertAdjacentHTML(
              "beforeend",
              hiddenSelectOptionTemplate({ label, value })
            );
        });

      const options = leftOptions || this.getAllAvailableOptions(id);
      this.renderOptions({ id, options });

      const selectedOptions = this.getSelectedOptions(id);
      const nonSelectedOption = this.getNonSelectedOptions(id);

      onAddSelected({ selectedOptions, nonSelectedOption });
      onTransaction({ selectedOptions, nonSelectedOption });
    });

    rightColumnRemoveSelectedButton.on("click", () => {
      _$(`#${id} .right-side-options option:checked`)
        .sel()
        .forEach((option) => {
          option.remove();
        });

      const options = leftOptions || this.getAllAvailableOptions(id);
      this.renderOptions({ id, options });

      const selectedOptions = this.getSelectedOptions(id);
      const nonSelectedOption = this.getNonSelectedOptions(id);

      onRemoveSelected({ selectedOptions, nonSelectedOption });
      onTransaction({ selectedOptions, nonSelectedOption });
    });

    //

    const selectAllButtonLeft = _$(`#${id} .select-all-left`);
    const selectNoneButtonLeft = _$(`#${id} .select-none-left`);

    selectAllButtonLeft.on("click", () => {
      multiSelectLeftOptionWrapper
        .find("option:not([hidden])")
        .attr("selected", "selected");
      return false;
    });

    selectNoneButtonLeft.on("click", () => {
      const options = leftOptions || this.getAllAvailableOptions(id);
      this.renderLeftSideOptions({ id, options });
    });

    const selectAllButtonRight = _$(`#${id} .select-all-right`);
    const selectNoneButtonRight = _$(`#${id} .select-none-right`);

    selectAllButtonRight.on("click", () => {
      multiSelectRightOptionWrapper.find("option").attr("selected", true);
    });

    selectNoneButtonRight.on("click", () => {
      const options = leftOptions || this.getAllAvailableOptions(id);
      this.renderRightSideOptions({ id, options });
    });

    //

    const leftFilterInput = _$(`#${id} .left-filter-input`);
    const leftClearFilterButton = _$(`#${id} .left-clear-filter-btn`);

    leftFilterInput.on("input", () => {
      const options = leftOptions || this.getAllAvailableOptions(id);
      this.renderLeftSideOptions({ id, options });
    });

    leftClearFilterButton.on("click", () => {
      leftFilterInput.val("");
      const options = leftOptions || this.getAllAvailableOptions(id);
      this.renderLeftSideOptions({ id, options });
    });

    const rightFilterInput = _$(`#${id} .right-filter-input`);
    const rightClearFilterButton = _$(`#${id} .right-clear-filter-btn`);

    rightFilterInput.on("input", () => {
      this.renderRightSideOptions({ id });
    });

    rightClearFilterButton.on("click", () => {
      rightFilterInput.val("");
      this.renderRightSideOptions({ id });
    });
  }

  renderLeftSideOptions = ({ id, options }) => {
    const multiSelectLeftOptionWrapper = _$(`#${id} .left-side-options`);
    const leftFilterInput = _$(`#${id} .left-filter-input`);
    const multiSelectRightOptionWrapper = _$(`#${id} .right-side-options`);

    //
    const optionList = this.getOptionsList(options);
    multiSelectLeftOptionWrapper.html("");

    optionList.forEach((option) => {
      const { label, value } = option;

      const isOptionSelected = multiSelectRightOptionWrapper
        .find(`[value="${value}"]`)
        .el();
      const doMatchFilter = label
        ?.toLowerCase()
        ?.includes(leftFilterInput.val()?.toLowerCase());

      const hidden = isOptionSelected || !doMatchFilter;

      multiSelectLeftOptionWrapper
        .el()
        .insertAdjacentHTML(
          "beforeend",
          multiSelectCardTemplate({ value, label, hidden })
        );
    });
  }

  renderRightSideOptions = ({ id }) => {
    const multiSelectRightOptionWrapper = _$(`#${id} .right-side-options`);
    const rightFilterInput = _$(`#${id} .right-filter-input`);

    //

    const selectedOptions = multiSelectRightOptionWrapper.find("option").sel();

    selectedOptions.forEach((option) => {
      const label = _$(option).text().trim();

      const doMatchFilter = label
        ?.toLowerCase()
        ?.includes(rightFilterInput.val()?.toLowerCase());

      if (!doMatchFilter) {
        _$(option).attr("hidden", true);
        return;
      }

      option.removeAttribute("hidden");
    });
  }

  renderOptions = ({ id, options }) => {
    this.renderLeftSideOptions({ id, options });
    this.renderRightSideOptions({ id });
  }

  updateSelectedOptions = ({ id, options }) => {
    const multiSelectRightOptionWrapper = _$(`#${id} .right-side-options`);

    if (!multiSelectRightOptionWrapper.el()) {
      return;
    }

    const optionList = this.getOptionsList(options);

    multiSelectRightOptionWrapper.html("");

    optionList.forEach((option) => {
      const label = option?.label;
      const value = option?.value;

      if (!label) {
        return;
      }

      multiSelectRightOptionWrapper
        .el()
        .insertAdjacentHTML(
          "beforeend",
          hiddenSelectOptionTemplate({ label, value })
        );
    });

    const leftOptions = this.getAllAvailableOptions(id);
    this.renderOptions({ id, options: leftOptions });
  }

  getSelectedOptions = (id) => {
    const multiSelectRightOptionWrapper = _$(`#${id} .right-side-options`);
    const selectedOptions = multiSelectRightOptionWrapper.find("option").sel();

    return selectedOptions.map((option) => {
      return { value: option.value, label: _$(option).text() };
    });
  }

  getNonSelectedOptions = (id) => {
    const multiSelectLeftOptionWrapper = _$(`#${id} .left-side-options`);
    const nonSelectedOption = multiSelectLeftOptionWrapper
      .find("option:not([hidden])")
      .sel();

    return nonSelectedOption.map((option) => {
      return { value: option.value, label: _$(option).text() };
    });
  }

  getAllAvailableOptions = (id) => {
    const multiSelectLeftOptionWrapper = _$(`#${id} .left-side-options`);
    const availableOptions = multiSelectLeftOptionWrapper.find("option").sel();

    return availableOptions.map((option) => {
      return { value: option.value, label: _$(option).text() };
    });
  }

  getOptionsList = (options) => {
    if (typeof options === "string") {
      return options.split(",").map((option) => {
        return { label: option, value: option };
      });
    }

    if (Array.isArray(options)) {
      return options;
    }

    return [];
  }
}
